<template>
	<div>
		<BaseSelect
			ref="BaseInput.licensePlateSelection"
			:required="true"
			v-if="showToggleButton"
			@input="toggleShowLicensePlate()"
			:label="$t('opponent')"
			:options="options"
			v-model="selectedOpponentOption"
			:allow-empty="false"
			:disabled="false"
		/>
		<div v-if="showPerson" class="flex flex-wrap w-full">
			<PersonNameForm ref="PersonNameForm" v-model="value.oppositePerson" :show-company="false" class="w-full" @input="updateValue" />
		</div>
		<LicensePlateInput ref="LicensePlateInput" v-model="value.oppositeLicensePlate" @input="updateValue" v-else />
		<div class="flex">
			<BaseInput
				class="w-1/2 pr-4"
				type="tel"
				:label="$t('case_number')"
				v-model="value.opposite_case_number"
				@input="updateValue"
				v-if="showOppositeCaseNumber"
			/>
			<BaseInput
				type="tel"
				class="w-1/2"
				:label="$t('contract_number')"
				v-model="value.opposite_insurance_contract_number"
				@input="updateValue"
				v-if="showOppositeCaseNumber"
			/>
		</div>

		<CompanyForm
			ref="CompanyForm"
			v-model="value.insurance"
			v-if="showOppositeInsurance"
			@input="updateValue"
			:required="false"
			:options="insuranceCompanyOptions"
			:custom-label="$t('foreign_insurance').toString()"
			:options-label="$t('opponent_insurance').toString()"
			:highlight_suffix="$t('add_new')"
			:show-postal-options="true"
		/>
	</div>
</template>

<script>
import { getPersonTitlesOptions } from '@/plugins/Utils';
import LicensePlateInput from '@/components/forms/inputs/LicensePlateInput';
import Validate from '@/mixins/Validate';
import PersonNameForm from '@/components/forms/PersonNameForm';
import BaseInput from '@/components/forms/inputs/BaseInput';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import CompanyForm from '@/components/damagecases/forms/CompanyForm.vue';
import { InsurancesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';

export default {
	components: { CompanyForm, BaseSelect, BaseInput, PersonNameForm, LicensePlateInput },
	mixins: [Validate],
	props: {
		showToggleButton: {
			default: true,
		},
		showOppositeCaseNumber: { default: false },
		showOppositeInsurance: { default: false },
		value: {
			type: Object,
			default() {
				return {
					oppositeLicensePlate: { isSpecial: false },
					oppositePerson: {},
					opposite_case_number: null,
					opposite_insurance_contract_number: null,
				};
			},
		},
	},
	data() {
		return {
			titles: getPersonTitlesOptions(),
			showPerson: undefined,
			options: [
				{ display: this.$t('save_opponent_as_license_plate'), value: false },
				{ display: this.$t('save_opponent_as_person'), value: true },
			],
			selectedOpponentOption: null,
			insuranceCompanyOptions: [],
		};
	},
	computed: {
		getShowLabel() {
			return !this.showPerson ? this.$t('save_opponent_as_person') : this.$t('save_opponent_as_license_plate');
		},
		isNameSet() {
			const oppositePerson = this.value.oppositePerson;
			return oppositePerson && (oppositePerson.firstName || oppositePerson.lastName);
		},
	},
	mounted() {
		this.selectedOpponentOption = this.options[0];
		InsurancesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
			.insurancesGet()
			.then(res => {
				this.insuranceCompanyOptions = res.data.filter(x => x.is_system_insurance);
			});
	},
	methods: {
		toggleShowLicensePlate() {
			this.showPerson = this.selectedOpponentOption !== this.options[0];
		},
		updateValue() {
			if (!this.showPerson) {
				this.$emit('input', { ...this.value, oppositePerson: {} });
			} else {
				this.$emit('input', { ...this.value, oppositeLicensePlate: {} });
			}
		},
	},
	watch: {
		value: {
			deep: true,
			immediate: true,
			handler() {
				if (this.showPerson === undefined) {
					this.showPerson = this.isNameSet;
				}
			},
		},
	},
};
</script>

<style lang="sass" scoped></style>
